"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosBlendIngredientUpdateInputSchema = exports.APosBlendIngredientCreateInputSchema = exports.APosBlendIngredientSchema = void 0;
const zod_1 = require("zod");
const id_schema_1 = require("../../common/id.schema");
/**
 * Module 29 — Oil Blending
 * BlendIngredient — join row: BlendRecipe ↔ Fragrance with percent.
 * PK = blendRecipeId, SK = ingredientId.
 *
 * Note: per-recipe ingredients sum to 100. Carrier oil is implicit
 * (100 − total_fragrance_percent on the parent recipe).
 *
 * tenantId is denormalised onto this row for cross-tenant safety in scans /
 * GSI projections — every join row still belongs to one tenant.
 */
const decimal2dp = (val) => Number.isFinite(val) && Math.round(val * 100) / 100 === val;
exports.APosBlendIngredientSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    blendRecipeId: id_schema_1.EntityIdSchema,
    ingredientId: id_schema_1.EntityIdSchema,
    fragrance_id: id_schema_1.EntityIdSchema,
    percent_of_fragrance_portion: zod_1.z.number().min(0).max(100).refine(decimal2dp, 'must be 2dp'),
});
exports.APosBlendIngredientCreateInputSchema = zod_1.z.object({
    fragrance_id: id_schema_1.EntityIdSchema,
    percent_of_fragrance_portion: zod_1.z.number().min(0).max(100).refine(decimal2dp, 'must be 2dp'),
});
exports.APosBlendIngredientUpdateInputSchema = exports.APosBlendIngredientCreateInputSchema.partial();
//# sourceMappingURL=blend-ingredient.schema.js.map